"use client";

import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { useState } from "react";
import { apiPost } from "../components/api";

export default function ResetPage() {
  const params = useSearchParams();
  const token = params.get("token");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onRequest = async () => {
    setError(null);
    setMessage(null);
    setLoading(true);
    try {
      await apiPost("/v1/auth/password-reset", { email });
      setMessage("Reset link sent if the account exists.");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  const onConfirm = async () => {
    if (!token) {
      return;
    }
    setError(null);
    setMessage(null);
    setLoading(true);
    try {
      await apiPost("/v1/auth/password-reset/confirm", {
        token,
        password
      });
      setMessage("Password updated. You can sign in now.");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <nav className="nav">
        <div className="brand">AudioHawk</div>
        <div className="links">
          <Link href="/">Home</Link>
          <Link href="/login">Login</Link>
        </div>
      </nav>

      <main className="hero">
        <div>
          <div className="section-title">Reset Password</div>
          <h1>{token ? "Set a new password." : "Recover access."}</h1>
          <p>
            {token
              ? "Enter your new password to complete the reset."
              : "We will send a reset link to your email address."}
          </p>
        </div>

        <div className="card">
          <h2>Reset</h2>
          <form
            className="form"
            onSubmit={(event) => {
              event.preventDefault();
              void (token ? onConfirm() : onRequest());
            }}
          >
            {token ? (
              <div>
                <label>New Password</label>
                <input
                  type="password"
                  placeholder="Create a strong password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </div>
            ) : (
              <div>
                <label>Email</label>
                <input
                  type="email"
                  placeholder="name@audiohawk.io"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </div>
            )}
            {message ? (
              <div style={{ color: "var(--muted)" }}>{message}</div>
            ) : null}
            {error ? <div style={{ color: "var(--muted)" }}>{error}</div> : null}
            <button className="button" type="submit" disabled={loading}>
              {loading
                ? "Sending..."
                : token
                  ? "Update Password"
                  : "Send Reset Link"}
            </button>
            {token ? (
              <Link href="/login" className="section-title">
                Return to login
              </Link>
            ) : null}
          </form>
        </div>
      </main>
    </div>
  );
}
